import { render, staticRenderFns } from "./CompProfileEditMultipleChoice.vue?vue&type=template&id=ba9e9620&scoped=true"
import script from "./CompProfileEditMultipleChoice.vue?vue&type=script&setup=true&lang=js"
export * from "./CompProfileEditMultipleChoice.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba9e9620",
  null
  
)

export default component.exports